export default "__VITE_ASSET__BhK_pLdF__"